<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    ref="table"
  >
    <template #DETAIL="{ visible, params, close }">
      <Details :row="params.row" :close="close" v-if="visible" />
    </template>
  </cTable>
</template>

<script>
import {
  getList,
  add,
  getDetails,
  update,
  del,
  create_bill,
} from "@/api/finance/airIncomeDetail";
import cTable from "@/base/common/index";
import { getAllClient } from "@/api/user/client";
import { getSelectType } from "@/api/public";
import Details from "./details";
export default {
  name: "airIncomeDetail",
  components: {
    cTable,
    Details,
  },
  mounted() {},
  data() {
    let selectOptions = [
      { label: this.$t("wechat") + this.$t("pay"), value: "WePay" },
      { label: this.$t("alipay") + this.$t("pay"), value: "AliPay" },
      { label: this.$t("cash") + this.$t("pay"), value: "Check" },
      { label: this.$t("BankTransfer"), value: "BankTransfer" },
    ];
    return {
      methods: {
        list: getList,
        getDetails,
        add,
        update,
        del,
        create_bill,
      },
      modals: {
        showDetail: {
          contentSlot: "DETAIL",
          config: {
            modalBind: {
              width: 1550,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px",
              },
            },
          },
          methods: {
            // cancel() {
            //   this.$page.getList();
            // }
          },
          footer: {
            show: () => false,
          },
          table: {
            height: 500,
          },
        },
        create_bill: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("create_bill", row)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$t("createBill"),
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{ bill_name: 24 }],
          fields: [
            {
              name: () => this.$t("b2bName"),
              key: "bill_name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("b2bName"),
            },
          ],
        },
        add: {
          methods: {
            ok({ row, close }) {
              let type = "add";
              if (row.id) {
                type = "update";
              }
              this.$page.handleRequestMethods(type, row).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            title: this.$t("add"),
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              payment_title: [
                {
                  required: true,
                  message: "title cannot be empty",
                  trigger: "blur",
                },
              ],
              payment_type: [
                {
                  required: true,
                  message: "type cannot be empty",
                  trigger: "blur",
                },
              ],
              payment_account: [
                {
                  required: true,
                  message: "account be empty",
                  trigger: "blur",
                },
              ],
              payment_description: [
                {
                  required: true,
                  message: "description cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            { payment_title: 24 },
            { payment_type: 24 },
            { payment_account: 24 },
            { payment_description: 24 },
          ],
          fields: [
            {
              name: () => this.$t("payment_title"),
              key: "payment_title",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("payment_title"),
            },
            {
              name: () => this.$t("type"),
              key: "payment_type",
              component: "Select",
              placeholder: () => this.$t("enter") + this.$t("type"),
              options: selectOptions,
            },
            {
              name: () => this.$t("payment_account"),
              key: "payment_account",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("payment_account"),
            },
            {
              name: () => this.$t("payment_description"),
              key: "payment_description",
              component: "Input",
              placeholder: () =>
                this.$t("enter") + this.$t("payment_description"),
            },
          ],
        },
      },
      footer: { show: () => true },
      header: {
        searchs: [
          {
            key: "time_type",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: [],
            methods: {
              list({ field }) {
                getSelectType("AIR_INCOME_SELECT_TYPE").then((res) => {
                  if (res.data.status) {
                    field.options = res.data.payload["AIR_INCOME_SELECT_TYPE"];
                  }
                });
              },
            },
          },
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              },
            },
          },
          {
            key: "create_bill",
            placeholder() {
              return this.$t("whether") + this.$t("createBill");
            },
            component: "Select",
            options: [
              { label: this.$t("isOrder"), value: "YES" },
              { label: this.$t("noOrder"), value: "NO" },
            ],
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: { label: "account", value: "id" },
            methods: {
              list({ field }) {
                getAllClient().then((res) => {
                  if (res.data.status) {
                    field.options = res.data.payload.rows;
                  }
                });
              },
            },
          },
					{
					  key: "bill_status",
					  placeholder() {
					    return this.$t("whether") + this.$t("bill_type");
					  },
					  component: "Select",
					  options: [
					    { label: this.$t("noOrder"), value: 0 },
					    { label: this.$t("isOrder"), value: 1 },
					    { label: this.$t("PendingWriteOff"), value: 4 },
					    { label: this.$t("WrittenOff"), value: 9 },
					  ],
					},
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 1, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
              id: 135,
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: () => this.$t("createBill"),
              type: "create",
              fnName: "create",
              bind: {
                type: "primary",
              },
              id: 1117,
            },
          ],
          methods: {
            create({ searchForm }) {
							let ids = this.selectAll.map(t=>t.id)
              this.getModal("create_bill").open({...searchForm,ids});
            },
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("outboundTime"),
          key: "outbound_time",
          width: 130,
          align: "center",
        },
        {
          name: () => this.$t("mawb"),
          key: "mawb",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("departureAirport"),
          key: "from_station",
          width: 100,
          align: "center",
        },
        {
          name: () => this.$t("airport"),
          key: "to_station",
          width: 100,
          align: "center",
        },
        {
          name: () => this.$t("salesman"),
          key: "salesman",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("preferential"),
          minWidth: 100,
          key: "header_name",
        },
        {
          name: () => this.$t("shipper_company_cn"),
          key: "company_cn",
          width: 100,
        },
        {
          name: () => this.$t("CTNS"),
          key: "items",
          width: 100,
        },
        {
          name: () => this.$t("invoiceWeight"),
          key: "weight",
          width: 100,
        },
        {
          name: () => this.$t("skuVolume"),
          key: "volume",
          width: 100,
        },
        {
          name: () => this.$t("charge_params"),
          key: "charge_weight",
          width: 100,
        },
        {
          name: () => this.$t("income"),
          children: [
            {
              name: () => this.$t("to_rmb"),
              key: "income_cny",
              align: "center",
              minWidth: 100,
            },
            {
              name: () => this.$t("to_usd"),
              key: "income_usd",
              align: "center",
              minWidth: 100,
            },
            {
              name: () => this.$t("to_hkd"),
              key: "income_hkd",
              align: "center",
              minWidth: 100,
            },
            {
              name: () => this.$t("to_sar"),
              key: "income_sar",
              align: "center",
              minWidth: 100,
            },
          ],
        },
        {
          name: () => this.$t("createName"),
          key: "create_name",
          align: "center",
          minWidth: 100,
        },
				{
				  name: () => this.$t("bill_number"),
				  key: "bill_number",
				  align: "center",
				  minWidth: 150,
					component:'a',
					methods:{
						click({row}){
							this.$refs['xTable'].closeTooltip()
							this.$router.push({
							  name: "airIncomeBill"
							});
							this.$store.dispatch("pageUrl", row.bill_number);
						}
					}
				},
				{
				  name: () => this.$t("bill_type"),
				  key: "bill_status",
				  width: 180,
				  align: "center",
				},
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 180,
          align: "center",
        },
        {
          type: "btns",
          name: () => this.$t("operation"),
          fixed: "right",
          width: 100,
          list: [
            {
              name: () => this.$t("detail"),
              type: "detail",
              fnName: "detail",
              bind: {
                type: "error",
              },
            },
          ],
          methods: {
            detail({ row }) {
              this.getModal("showDetail").open({ row }, function () {
                this.setTitle(row.mawb + "(" + this.$t("detail") + ")");
              });
            },
          },
        },
      ],
    };
  },
};
</script>
